module.exports = __webpack_public_path__ + "static/media/collapse-arrow-down.484fb3e6.svg";